import React from 'react';
import {createRoot} from 'react-dom/client';
import {hydrateRoot} from 'react-dom/client';
import {Provider} from "mobx-react";
import {createInertiaApp} from '@inertiajs/react';
import {InertiaProgress} from '@inertiajs/progress';
import {resolvePageComponent} from 'laravel-vite-plugin/inertia-helpers';
import {AppProviders} from "@/app/providers/AppProviders";
import rootStores from '@/Stores/RootStores';
import './bootstrap';
import "@/app/styles/fonts/fonts.scss";
import "@/app/styles/index.scss";
import "@/Scss/index.scss";

InertiaProgress.init({color: '#24564A'});

createInertiaApp({
    title: (title) => `${title}`,
    resolve: (name) => resolvePageComponent(`./pages/${name}.jsx`, import.meta.glob('./pages/**/*.jsx')),
    setup({el, App, props}) {
        const isSSR = !!props.initialPage?.props?.is_ssr;
        const pageProps = props.initialPage.props;

        if (isSSR) {
            // SSR страница → hydrate
            hydrateRoot(
                el,
                <Provider stores={rootStores}>
                    <AppProviders providerProps={pageProps}>
                        <App {...props}/>
                    </AppProviders>
                </Provider>
            );
        } else {
            // CSR страница → обычный рендер
            createRoot(el).render(
                <Provider stores={rootStores}>
                    <AppProviders providerProps={pageProps}>
                        <App {...props}/>
                    </AppProviders>
                </Provider>
            );
        }
    },
    defaults: {
        future: {
            useDataInertiaHeadAttribute: true,
        },
    },
});
